import { useRoutes } from "react-router-dom";
import { lazy, Suspense } from "react";
import General from "../Layouts/general";
import PrivateRoutes from "../UserPages/PrivateRoutes";
import TopLoader from "../PreLoad/LoaderTop";
import ScrollToTop from "../GuestPages/ScrollToTop";
import EditDocument from "../UserPages/EditDocument";

// Lazy-loaded components
const Home = lazy(() => import("../GuestPages/Home"));
const About = lazy(() => import("../GuestPages/About"));
const AdvanceSearch = lazy(() => import("../GuestPages/Advance"));
const Result = lazy(() => import("../GuestPages/Result"));
const Signin = lazy(() => import("../GuestPages/Signin"));
const ConfirmEmail = lazy(() => import("../UserPages/EmailVerify"));
const ResourceForm = lazy(() => import("../GuestPages/Test"));
const CategoryDetail = lazy(() => import("../GuestPages/CategoryDetail"));
const Detail = lazy(() => import("../GuestPages/Details"));
const DetailMore = lazy(() => import("../GuestPages/MoreDetails"));
const Framework = lazy(() => import("../GuestPages/Framework"));
const Contact = lazy(() => import("../GuestPages/Contact"));
const Donation = lazy(() => import("../GuestPages/Donation"));
const GuestFaq = lazy(() => import("../GuestPages/GuestFaq"));

// Lazy-load user pages
const Dashboard = lazy(() => import("../UserPages/DashBoard"));
const DocumentUpload = lazy(() => import("../UserPages/DocumentUpload"));
const UserResources = lazy(() => import("../UserPages/Resources"));
const ResourceDetail = lazy(() => import("../UserPages/ResourceDetail"));
const UserResourceProfile = lazy(() => import("../UserPages/UserResourceProfile"));
const UserSetting = lazy(() => import("../UserPages/Setting"));
const FaqSupport = lazy(() => import("../UserPages/FaqSupport"));
const MyResourceDetail = lazy(() => import("../UserPages/MyResourceDetail"));
const PublicProfile = lazy(() => import("../UserPages/PublicProfile"));
const ChatPage = lazy(() => import("../UserPages/Message"));

export default function Routers() {
  return (
    <Suspense fallback={<TopLoader />}>
      <ScrollToTop />
      {useRoutes([
        {
          path: "/",
          element: <General />,
          children: [
            { path: "/", element: <Home /> },
            { path: "/about", element: <About /> },
            { path: "/advanceSearch", element: <AdvanceSearch /> },
            { path: "/result", element: <Result /> },
            { path: "/signin", element: <Signin /> },
            { path: "/confirmEmail", element: <ConfirmEmail /> },
            { path: "/test", element: <ResourceForm /> },
            { path: "/categoryDetails", element: <CategoryDetail /> },
            { path: "/detailPage/:id", element: <Detail /> },
            { path: "/detailPages/:id", element: <DetailMore /> },
            { path: "/framework", element: <Framework /> },
            { path: "/contact", element: <Contact /> },
            { path: "/donation", element: <Donation /> },
            { path: "/faq", element: <GuestFaq /> },
          ],
        },
        {
          path: "/users",
          element: <PrivateRoutes />,
          children: [
            { path: "/users/dashboard", element: <Dashboard /> },
            { path: "/users/documentUpload", element: <DocumentUpload /> },
            { path: "/users/resources", element: <UserResources /> },
            { path: "/users/resources/details/:id", element: <ResourceDetail /> },
            { path: "/users/my-resources/details/:id", element: <MyResourceDetail /> },
            { path: "/users/resources/profile/:id", element: <UserResourceProfile /> },
            { path: "/users/setting", element: <UserSetting /> },
            { path: "/users/faq", element: <FaqSupport /> },
            { path: "/users/message", element: <ChatPage /> },
            { path: "/users/public-profile", element: <PublicProfile /> },
            { path: "/users/editdocument/:id", element: <EditDocument /> },
          ],
        },
      ])}
    </Suspense>
  );
}
